import React from 'react';
import { useRouter } from 'next/router';
import { useClearRefinements } from 'react-instantsearch';
import { PRODUCT_SEARCH_FACETS_ARRAY } from '@/lib/services/typesense/constants';

export function ClearFiltersButton({ closeDrawers }: any) {
const router = useRouter();

  const { refine } = useClearRefinements({
    includedAttributes: [...PRODUCT_SEARCH_FACETS_ARRAY, 'categories.name'],
  });

  function clearFilters() {
    const {
      price,
      category,
      sortedBy,
      orderBy,
      tags,
      manufacturer,
      text,
      ...rest
    } = router.query;

    refine();
    closeDrawers?.();
    router.push('/search');
  }

  return (
    <button type="button"
      className="text-sm font-semibold text-body transition-colors hover:text-red-500 focus:text-red-500 focus:outline-0 lg:m-0"
      onClick={clearFilters}
    >
      {"Limpar Tudo"}
    </button>
  );
}
